import { hasStorageDataFlag } from '../wildix/functions.any';
import Env from '../wildix/modules/Environment';


const storeConfig = {
    startAudioOnly: hasStorageDataFlag('wildix/features/audio-only'),

    /**
     * Configure standard WebRTC audio parameters
     */
    // Disables Acoustic Echo Cancellation
    disableAEC: hasStorageDataFlag('disableAEC'),

    // Disables Automatic Gain Control
    disableAGC: hasStorageDataFlag('disableAGC'),

    // Disables Noise Suppression
    disableNS: hasStorageDataFlag('disableNS'),

    // Disables all audio processing
    disableAP: hasStorageDataFlag('disableAP')
};

window.config = Object.assign(storeConfig, window.config);
window.EXCALIDRAW_ASSET_PATH = Env.isLocalHost() ? '/libs/' : `${Env.checkIfConfigPHPExist()}libs/`;
